"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var io = require("socket.io-client");
var sub_events_1 = require("sub-events");
var Errors_1 = require("./Errors");
var WebsocketsConnector = /** @class */ (function () {
    function WebsocketsConnector(authManager, logger) {
        var _this = this;
        this.authManager = authManager;
        this.logger = logger;
        this.connected = false;
        this.authorized = false;
        /* eslint-disable @typescript-eslint/no-explicit-any */
        this.subscriptions = {};
        /* eslint-enable @typescript-eslint/no-explicit-any */
        this.subscribedChannels = [];
        this.onConnectedChange = new sub_events_1.SubEvent();
        this.onAuthorizedChange = new sub_events_1.SubEvent();
        this.onSubscriptionsChange = new sub_events_1.SubEvent();
        var authState = this.authManager.getState();
        if (authState.authenticated) {
            this.initializeConnection();
        }
        this.authManager.onAuthUpdated.subscribe(function (auth) {
            if (!auth.authenticated && _this.connected) {
                if (_this.socket)
                    _this.socket.disconnect();
                delete _this.socket;
            }
            else if (auth.authenticated && !_this.connected) {
                _this.initializeConnection();
            }
        });
        this.onConnectedChange.subscribe(function (connected) {
            _this.connected = connected;
            if (_this.connected) {
                if (!_this.authorized)
                    _this.attemptAuthorization();
            }
            else {
                _this.authorized = false;
            }
        });
        this.onAuthorizedChange.subscribe(function (authorized) {
            _this.authorized = authorized;
            if (_this.authorized) {
                _this.logger.log("Ready for real-time updates");
                for (var _i = 0, _a = Object.keys(_this.subscriptions); _i < _a.length; _i++) {
                    var key = _a[_i];
                    _this.onSubscriptionsChange.emit(key);
                }
            }
            else {
                _this.logger.log("Failed to subscribe to real-time updates", "error");
            }
        });
        this.onSubscriptionsChange.subscribe(function (key) {
            var _a = key.split("/"), event = _a[0], channel = _a[1];
            if (!_this.authorized)
                return;
            if (_this.socket && !_this.subscribedChannels.includes(channel)) {
                _this.socket.on(channel, _this.processIncomingMessage(channel));
                _this.subscribedChannels.push(channel);
                _this.logger.debug("Subscribed to ".concat(event, " events on ").concat(channel, " channel"));
            }
            if (_this.socket) {
                _this.socket.emit("subscribe", event);
            }
        });
    }
    WebsocketsConnector.prototype.initializeConnection = function () {
        var _this = this;
        this.socket = io("https://".concat(this.authManager.getOptions().domain), {
            path: "/pulse",
            transports: ["websocket", "polling"]
        });
        this.socket.on("connect", function () {
            _this.onConnectedChange.emit(true);
        });
        this.socket.on("disconnect", function () {
            _this.logger.log("Disconnected from real-time updates");
            _this.onConnectedChange.emit(false);
        });
        this.socket.on("authorized", function () {
            _this.onAuthorizedChange.emit(true);
        });
        this.socket.on("unauthorized", function () {
            _this.onAuthorizedChange.emit(false);
        });
    };
    WebsocketsConnector.prototype.attemptAuthorization = function () {
        if (!this.socket || !this.connected || (this.connected && this.authorized)) {
            throw new Errors_1.OrderOfOperationsError("Must initializeConnection() before attemptAuthorization()");
        }
        this.socket.emit("authorize", JSON.stringify({
            access_token: this.authManager.getState().access_token,
            chariot_host: this.authManager.getOptions().domain
        }));
    };
    WebsocketsConnector.prototype.emit = function (event, payload) {
        var _this = this;
        if (!this.socket || !this.connected) {
            throw new Errors_1.OrderOfOperationsError("Must initializeConnection() before emit()");
        }
        if (!this.authorized) {
            var subscription_1 = this.onAuthorizedChange.subscribe(function (authorized) {
                if (authorized && _this.socket) {
                    _this.socket.emit(event, JSON.stringify(payload));
                    subscription_1.cancel();
                }
            });
        }
        else {
            this.socket.emit(event, JSON.stringify(payload));
        }
    };
    WebsocketsConnector.prototype.subscribe = function (event, channel, handler) {
        var subKey = "".concat(event, "/").concat(channel);
        if (!Object.prototype.hasOwnProperty.call(this.subscriptions, subKey)) {
            this.subscriptions[subKey] = new sub_events_1.SubEvent();
        }
        this.onSubscriptionsChange.emit(subKey);
        return this.subscriptions[subKey].subscribe(handler);
    };
    WebsocketsConnector.prototype.unsubscribe = function (event, channel, subscription) {
        var subKey = "".concat(event, "/").concat(channel);
        if (!Object.prototype.hasOwnProperty.call(this.subscriptions, subKey) || !this.socket) {
            return;
        }
        if (subscription) {
            subscription.cancel();
        }
        else {
            this.subscriptions[subKey].cancelAll();
        }
        if (this.subscriptions[subKey].count < 1) {
            delete this.subscriptions[subKey];
            this.socket.emit("unsubscribe", event);
        }
    };
    WebsocketsConnector.prototype.processIncomingMessage = function (channel) {
        var _this = this;
        return function (data) {
            var subscriptions = Object.keys(_this.subscriptions).filter(function (key) { return key.split("/")[1] == channel; });
            for (var _i = 0, subscriptions_1 = subscriptions; _i < subscriptions_1.length; _i++) {
                var subscription = subscriptions_1[_i];
                _this.subscriptions[subscription].emit(data);
            }
        };
    };
    return WebsocketsConnector;
}());
exports.default = WebsocketsConnector;
